export default __webpack_public_path__ + "static/media/aff-illus.0d897b55.svg";